import React, { useState, useEffect } from 'react';
import Api from '../api/api';
import { Stage, Layer, Ellipse, Rect, Transformer } from 'react-konva';
import { Modal } from 'react-bootstrap';
import arrayUtilities from '../../utilities/arrayUtilities';
import { toDateTimeString } from '../../utilities/dateUtilities';

export default function RedactionPane(props) {

    const isInGalleryMode = props.isAttachment && props.images?.length > 0;
    const imageSelector = isInGalleryMode ? ".carousel-item.active .redaction-pane-image" : ".redaction-pane-image";

    const [modalVisible, setModalVisible] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(props.initialIndex ?? 0);
    const [rectangles, setRectangles] = useState([]);
    const [ovals, setOvals] = useState([]);
    const [selectedId, selectShape] = useState(null);

    const safeIndex = isInGalleryMode ? Math.min(currentIndex, props.images.length - 1) : 0;
    const activeId = isInGalleryMode ? props.images[safeIndex].id : props.id;

    useEffect(() => {
        if (isInGalleryMode && currentIndex >= props.images.length) {
            setCurrentIndex(Math.max(0, props.images.length - 1));
        }
    }, [props.images?.length]);

    useEffect(() => {
        setRectangles([]);
        setOvals([]);
        selectShape(null);
    }, [currentIndex]);

    const imageCount = props.images?.length ?? 1;
    const goToPrev = () => setCurrentIndex(i => (i - 1 + imageCount) % imageCount);
    const goToNext = () => setCurrentIndex(i => (i + 1) % imageCount);

    useEffect(() => {
        if (!isInGalleryMode || !modalVisible) return;
        const handleKeyDown = (e) => {
            if (e.key === 'ArrowLeft') goToPrev();
            if (e.key === 'ArrowRight') goToNext();
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [isInGalleryMode, modalVisible, currentIndex]);

    const checkDeselect = (e) => {
        // deselect when clicked on empty area
        const clickedOnEmpty = e.target === e.target.getStage();
        if (clickedOnEmpty) {
            selectShape(null);
        }
    };

    const addNewRect = function () {
        var id = 'rect' + rectangles.length;
        const newRect = {
            x: 250,
            y: 200,
            width: 100,
            height: 100,
            fill: 'black',
            id: id,
        };

        var tempArray = [];
        rectangles.forEach(item => {
            tempArray.push(item);
        });
        tempArray.push(newRect)
        setRectangles(tempArray);

        selectShape(id);
    }

    const addNewOval = function () {
        var id = 'oval' + ovals.length;
        const newOval = {
            x: 250,
            y: 200,
            width: 100,
            height: 100,
            fill: 'black',
            id: id,
        };

        var tempArray = [];
        ovals.forEach(item => {
            tempArray.push(item);
        });
        tempArray.push(newOval)
        setOvals(tempArray)

        selectShape(id);
    }

    const deleteItem = function () {
        var tempRects = [];
        rectangles.forEach(item => {
            if (selectedId !== item.id) {
                tempRects.push(item);
            }
        });
        setRectangles(tempRects)
        var tempOvals = [];

        ovals.forEach(item => {
            if (selectedId !== item.id) {
                tempOvals.push(item);
            }
        });
        setOvals(tempOvals)
    }

    const confirm = function () {
        var redactions = [];

        rectangles.forEach(item => {
            var redaction = new Object();
            redaction.redactionShape = 0;
            redaction.x = parseInt(item.x);
            redaction.y = parseInt(item.y);
            redaction.width = parseInt(item.width);
            redaction.height = parseInt(item.height);
            console.log(item)

            redactions.push(redaction);
        });

        ovals.forEach(item => {
            var redaction = new Object();
            redaction.redactionShape = 1;
            redaction.x = parseInt(item.x) - item.width / 2;
            redaction.y = parseInt(item.y) - item.height / 2;
            redaction.width = parseInt(item.width);
            redaction.height = parseInt(item.height);

            redactions.push(redaction);
        });

        if (!arrayUtilities.isNullOrEmpty(redactions)) {
            if (props.isAttachment) {
                Api.redactAttachment(
                    () => {
                        setRectangles([]);
                        setOvals([]);
                        props.onChange();
                    },
                    (error) => console.log(error),
                    document.querySelector(imageSelector)?.clientWidth, document.querySelector(imageSelector)?.clientHeight,
                    redactions,
                    props.organisationId,
                    activeId,
                    props.token
                )
            } else {
                Api.redact(
                    () => {
                        setRectangles([]);
                        setOvals([]);
                        props.onChange();
                    },
                    (error) => console.log(error),
                    document.querySelector(imageSelector)?.clientWidth, document.querySelector(imageSelector)?.clientHeight,
                    redactions,
                    props.organisationId,
                    activeId,
                    props.token
                )
            }
        }

        setModalVisible(false);
    }

    return (
        <>
            <button className="button-no-style text-center" onClick={() => setModalVisible(true)}>
                <img src={props.url} className="attachment-thumb" />
            </button>
            <Modal size='sm' fullscreen={false} show={modalVisible} onHide={() => { setModalVisible(false); setCurrentIndex(props.initialIndex ?? 0); }} dialogClassName="redaction-pane">
                {isInGalleryMode && (
                    <Modal.Header className="bg-white d-flex justify-content-between p-2">
                        <p className='m-0 text-truncate mr-2' style={{ flex: 1, minWidth: 0 }} title={ props.images[safeIndex].filename }>{ props.images[safeIndex].filename }</p>
                        <p className='m-0 flex-shrink-0'>{ toDateTimeString(props.images[safeIndex].timestamp) }</p>
                    </Modal.Header>
                )}
                <div style={{ position: 'relative' }}>
                    {isInGalleryMode ? (
                        <div className="carousel slide">
                            <div className="carousel-inner">
                                { props.images.map((image, i) => (
                                    <div key={ image.id } className={ `carousel-item${ i === safeIndex ? ' active' : '' }` }>
                                        <div className="redaction-pane-image">
                                            <img src={ image.url } alt="" />
                                        </div>
                                    </div>
                                )) }
                            </div>
                            { props.images.length > 1 && (
                                <>
                                    <button className="carousel-control-prev gallery-chevron" onClick={ goToPrev }>
                                        <i className="fas fa-chevron-left" aria-hidden="true" />
                                    </button>
                                    <button className="carousel-control-next gallery-chevron" onClick={ goToNext }>
                                        <i className="fas fa-chevron-right" aria-hidden="true" />
                                    </button>
                                </>
                            ) }
                        </div>
                    ) : (
                        <div className="redaction-pane-image">
                            <img src={props.url} />
                        </div>
                    )}
                    <Stage
                        width={document.querySelector(imageSelector)?.clientWidth}
                        height={document.querySelector(imageSelector)?.clientHeight}
                        onMouseDown={checkDeselect}
                        onTouchStart={checkDeselect}
                        style={{ position: "absolute", top: 0, left: 0 }}
                    >
                    <Layer>
                        {rectangles.length > 0 && rectangles.map((rect, i) => {
                            return (
                                <Rectangle
                                    key={i}
                                    shapeProps={rect}
                                    isSelected={rect.id === selectedId}
                                    onSelect={() => {
                                        selectShape(rect.id);
                                    }}
                                    onChange={(newAttrs) => {
                                        const rects = rectangles.slice();
                                        rects[i] = newAttrs;
                                        setRectangles(rects);
                                    }}
                                />
                            );
                        })}
                        {ovals.length > 0 && ovals.map((oval, j) => {
                            return (
                                <Oval
                                    key={j}
                                    shapeProps={oval}
                                    isSelected={oval.id === selectedId}
                                    onSelect={() => {
                                        selectShape(oval.id);
                                    }}
                                    onChange={(newAttrs) => {
                                        const oval = ovals.slice();
                                        oval[j] = newAttrs;
                                        setOvals(oval);
                                    }}
                                />
                            );
                        })}
                    </Layer>
                </Stage>
                </div>

                <div className="bg-white d-flex justify-content-between p-2">
                    <div>
                        <button className="btn btn-primary btn-sm mr-2" onClick={() => addNewRect()}>Add Box <i className="fas fa-plus"></i></button>
                        <button className="btn btn-primary btn-sm mr-2" onClick={() => addNewOval()}>Add Oval <i className="fas fa-plus"></i></button>
                        <button className="btn btn-danger btn-sm" onClick={() => deleteItem()}>Delete Selected <i className="fas fa-times"></i></button>
                    </div>
                    {isInGalleryMode && props.images.length > 1 && (
                        <span className="small d-flex align-items-center">{currentIndex + 1} / {props.images.length}</span>
                    )}
                    <button className="btn btn-success btn-sm" onClick={() => confirm()}>Confirm <i className="fas fa-check"></i></button>
                </div>

            </Modal>
        </>
    )
}

const Rectangle = ({ shapeProps, isSelected, onSelect, onChange }) => {
    const shapeRef = React.useRef();
    const trRef = React.useRef();

    useEffect(() => {
        if (isSelected) {
            // we need to attach transformer manually
            trRef.current.nodes([shapeRef.current]);
            trRef.current.getLayer().batchDraw();
        }
    }, [isSelected]);

    return (
        <React.Fragment>
            <Rect
                onClick={onSelect}
                onTap={onSelect}
                ref={shapeRef}
                {...shapeProps}
                draggable
                onDragEnd={(e) => {
                    onChange({
                        ...shapeProps,
                        x: e.target.x(),
                        y: e.target.y(),
                    });
                }}
                onTransformEnd={(e) => {
                    // transformer is changing scale of the node
                    // and NOT its width or height
                    // but in the store we have only width and height
                    // to match the data better we will reset scale on transform end
                    const node = shapeRef.current;
                    const scaleX = node.scaleX();
                    const scaleY = node.scaleY();

                    // we will reset it back
                    node.scaleX(1);
                    node.scaleY(1);
                    onChange({
                        ...shapeProps,
                        x: node.x(),
                        y: node.y(),
                        // set minimal value
                        width: Math.max(5, node.width() * scaleX),
                        height: Math.max(node.height() * scaleY),
                    });
                }}
            />
            {isSelected && (
                <Transformer
                    ref={trRef}
                    rotateEnabled={false}
                    boundBoxFunc={(oldBox, newBox) => {
                        // limit resize
                        if (newBox.width < 5 || newBox.height < 5) {
                            return oldBox;
                        }
                        return newBox;
                    }}
                />
            )}
        </React.Fragment>
    );
};

const Oval = ({ shapeProps, isSelected, onSelect, onChange }) => {
    const shapeRef = React.useRef();
    const trRef = React.useRef();

    useEffect(() => {
        if (isSelected) {
            // we need to attach transformer manually
            trRef.current.nodes([shapeRef.current]);
            trRef.current.getLayer().batchDraw();
        }
    }, [isSelected]);

    return (
        <React.Fragment>
            <Ellipse
                onClick={onSelect}
                onTap={onSelect}
                ref={shapeRef}
                {...shapeProps}
                draggable
                onDragEnd={(e) => {
                    onChange({
                        ...shapeProps,
                        x: e.target.x(),
                        y: e.target.y(),
                    });
                }}
                onTransformEnd={(e) => {
                    // transformer is changing scale of the node
                    // and NOT its width or height
                    // but in the store we have only width and height
                    // to match the data better we will reset scale on transform end
                    const node = shapeRef.current;
                    const scaleX = node.scaleX();
                    const scaleY = node.scaleY();

                    // we will reset it back
                    node.scaleX(1);
                    node.scaleY(1);
                    onChange({
                        ...shapeProps,
                        x: node.x(),
                        y: node.y(),
                        // set minimal value
                        width: Math.max(5, node.width() * scaleX),
                        height: Math.max(node.height() * scaleY),
                    });
                }}
            />
            {isSelected && (
                <Transformer
                    ref={trRef}
                    rotateEnabled={false}
                    boundBoxFunc={(oldBox, newBox) => {
                        // limit resize
                        if (newBox.width < 5 || newBox.height < 5) {
                            return oldBox;
                        }
                        return newBox;
                    }}
                />
            )}
        </React.Fragment>
    );
};
